import { format } from 'date-fns';
import { useMemo } from 'react';

import { Chart, ChartOption } from 'components/common';

import { PixelChartProps } from './PixelVerificationTypes';

export const PixelChart = ({ data, children }: PixelChartProps) => {
  const option: ChartOption | null = useMemo(() => {
    const filtered = data?.filter((i) => i.date);

    if (!filtered) return null;

    // CAA-114: when the user picks a single-day range like "Today", filtered has
    // at most one entry. With showMinLabel/showMaxLabel both false, the only
    // x-axis label is hidden; with the default showSymbol false, the lone point
    // doesn't render. Result: chart looks empty even though data is present.
    // Force both visible when data is sparse.
    const isSparse = filtered.length <= 1;

    return {
      xAxis: {
        axisLabel: {
          formatter: (date: string) => format(new Date(date), 'MM/dd/yy'),
          showMinLabel: isSparse,
          showMaxLabel: isSparse,
        },
        data: filtered.map((e) => e.date),
      },
      grid: {
        left: 0,
        top: '24px',
        right: 0,
        bottom: '32px',
      },
      tooltip: {
        axisPointer: {
          label: {
            formatter: ({ value }: { value: string }) => format(new Date(value), 'MMM d, y'),
          },
        },
        className: 'ctv-chart-tooltip',
      },
      series: [
        {
          name: 'Pixel fires:',
          color: '#6D49D4',
          data: filtered.map((e) => e.events),
          showSymbol: isSparse,
        },
      ],
    };
  }, [data]);

  return (
    <div className="p-6 w-full">
      <div className="text-secondary-black text-base-sm font-semibold leading-snug">{children}</div>
      {option && <Chart option={option} />}
    </div>
  );
};
